// This code comes from Create React App’s default service worker registration
// Learn more about service workers: https://bit.ly/CRA-PWA

// The URL of the service worker. This can be customized.
const isLocalhost = Boolean(
  window.location.hostname === "localhost" ||
  window.location.hostname === "[::1]" ||
  window.location.hostname.startsWith("127.") ||
  window.location.hostname.startsWith("10.") ||
  window.location.hostname.startsWith("192.") ||
  window.location.hostname.startsWith("172.")
);

export function register(config) {
  // The worker caches same-origin files cache-first, which would serve a stale bundle.js
  // during development, so it only runs in production builds
  if (process.env.NODE_ENV !== "production") {
    unregister();
    return;
  }
  if ("serviceWorker" in navigator) {
    // The URL of the service worker file.
    const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

    if (isLocalhost) {
      // This is running on localhost. Let's check if a service worker is already registered.
      checkValidServiceWorker(swUrl, config);
    } else {
      // Is not localhost. Register the service worker.
      registerValidSW(swUrl, config);
    }
  }
}

function registerValidSW(swUrl, config) {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (installingWorker == null) {
          return;
        }
        installingWorker.onstatechange = () => {
          if (installingWorker.state === "installed") {
            if (navigator.serviceWorker.controller) {
              if (config && config.onUpdate) {
                config.onUpdate(registration);
              }
            }
          }
        };
      };
    })
    .catch((error) => {
    });
}

function checkValidServiceWorker(swUrl, config) {
  fetch(swUrl)
    .then((response) => {
      // Ensure service worker exists
      const contentType = response.headers.get("Content-Type");
      if (
        response.status === 404 ||
        (contentType != null && contentType.indexOf("javascript") === -1)
      ) {
        // No service worker found. Probably a different app.
        navigator.serviceWorker.ready.then((registration) => {
          registration.unregister().then(() => {
            window.location.reload();
          });
        });
      } else {
        // Service worker found. Proceed with registration.
        registerValidSW(swUrl, config);
      }
    })
    .catch(() => {
      
    });
}

export function unregister() {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      registrations.forEach((registration) => registration.unregister());
    });
  }
}
